import { isEmpty } from 'lodash/fp'
import styled from 'styled-components'

import { clickableImagesContent } from 'homepage/clickableImagesContent'
import { t } from 'localization'
import TrendingProducts from 'search/components/TrendingProducts'
import ClickableImagesRow from 'shared/components/ClickableImagesRow'
import GridHeader from 'shared/components/GridHeader'
import { colors, media } from 'shared/lib'
import { CSSearchState } from 'shared/utils/search/cs-utils'

const TP = 'search.components.SearchResults'

type SearchResultsDisplayProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  noResultsState: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  searchResults: any
  searchState: CSSearchState
}

export const SearchResultsDisplay = ({
  searchResults,
  searchState,
  noResultsState,
  children,
}: SearchResultsDisplayProps) => {
  const hasNoResults = (searchResults || [])?.length === 0

  const onlyQueryTermActive =
    !!searchState?.query && isEmpty(searchState?.refinementList) && isEmpty(searchState?.range)

  const noResultsTitle =
    searchState && !isEmpty(searchState.query)
      ? t(`${TP}.noResultsWithQuery`, {
          defaultValue: 'We could not find anything for "{searchStateQuery}"',
          searchStateQuery: searchState.query,
        })
      : t(`${TP}.noResults`, 'No results found')

  const displayNoResultsGrid = hasNoResults && onlyQueryTermActive

  return (
    <>
      {displayNoResultsGrid && (
        <>
          <GridHeader
            as="h2"
            title={noResultsTitle}
            description={t(
              `${TP}.noResultTitle`,
              'Check the spelling, search with a new term, or use links above to find what you are looking for.',
            )}
            textAlign="center"
          />
          {noResultsState && <TrendingProducts hits={noResultsState} />}
          <ClickableImagesRow imagesList={clickableImagesContent()} />
        </>
      )}
      {!displayNoResultsGrid && <GridContainer>{children}</GridContainer>}
    </>
  )
}


const GridContainer = styled.div`
  background-color: ${colors.FC2_OFF_WHITE};
  ${media.large`
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
`
